import React from "react";
import { Box, Typography, TextField, useMediaQuery } from "@mui/material";
import { format } from "date-fns";

import { Chairs } from "../icons";
import { remainingSets } from "../inventory";
import { MAX_SETS_PER_DAY } from "../config";

// Parse "YYYY-MM-DD" as a local date so the label matches the booked
// day in every timezone.
const parseDay = (dateString) => {
  const [year, month, day] = dateString.split("-").map(Number);
  return new Date(year, month - 1, day);
};

const Calendar = ({ dates, handleChange, sets, booked }) => {
  const row = useMediaQuery("(min-width:425px)");

  const renderChairs = (n) =>
    Array.from({ length: n }, (_, index) => (
      <Box key={index} sx={{ m: 0.25, display: "inline-flex" }}>
        <Chairs color="primary" />
      </Box>
    ));

  return (
    <Box
      display="flex"
      flexDirection={row ? "row" : "column"}
      justifyContent="space-around"
      sx={{
        border: 1,
        borderColor: "grey.300",
        borderRadius: 3,
        bgcolor: "background.paper",
        overflow: "hidden",
        m: 2,
        mb: 0,
      }}
    >
      {dates.map((dateString, i) => {
        const date = parseDay(dateString);
        const isLast = i === dates.length - 1;
        return (
          <Box
            key={dateString}
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="flex-start"
            p={1.5}
            sx={{
              flex: 1,
              borderRight: row && !isLast ? 1 : 0,
              borderBottom: !row && !isLast ? 1 : 0,
              borderColor: "grey.200",
            }}
          >
            <Typography
              variant="overline"
              color="primary"
              sx={{ lineHeight: 1.75 }}
            >
              {format(date, "eee")}
            </Typography>
            <Typography variant="h6" sx={{ mb: 1.5 }}>
              {format(date, "MMM d")}
            </Typography>
            <TextField
              label="Sets"
              type="text"
              variant="outlined"
              sx={{ maxWidth: 128, "& input": { textAlign: "center" } }}
              value={sets[i]}
              onChange={(e) => handleChange(e, i)}
              inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
            />
            {booked != null &&
              (() => {
                const remaining = remainingSets(booked, dateString);
                return (
                  <Box
                    sx={{
                      mt: 0.5,
                      textAlign: "center",
                      color:
                        remaining === 0
                          ? "error.main"
                          : remaining <= 10
                            ? "warning.main"
                            : "text.secondary",
                    }}
                  >
                    <Typography variant="caption" sx={{ display: "block", lineHeight: 1.3 }}>
                      {`${remaining} of ${MAX_SETS_PER_DAY}`}
                    </Typography>
                    <Typography variant="caption" sx={{ display: "block", lineHeight: 1.3 }}>
                      Sets Available
                    </Typography>
                  </Box>
                );
              })()}
            <Box sx={{ mt: 1 }}>{renderChairs(sets[i])}</Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default Calendar;
